import axios from "axios";

import { apiInstance } from "../api";

import CustomError from "../../domains/Utilities/CustomError";

import Requirement from "../../domains/Requirement";

import { ENDPOINT } from "./config";

export function createRequirement(postData: any): Promise<Requirement> {
  return apiInstance
    .post(`${ENDPOINT}`, postData)
    .then(response => response.data)
    .catch(error => {
      if(axios.isAxiosError(error)) {
        throw new CustomError(error?.response?.statusText as string, String(error?.response?.status));

      }
    });
}
